import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Checkbox, Dialog, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { CancelOutlined, KeyboardArrowLeft, KeyboardArrowRight, ReportProblemOutlined } from "@mui/icons-material";
import dayjs, { Dayjs } from "dayjs";
import aldi from '../../../assets/Project_Images/Aldi_logo.png'
import blooms from '../../../assets/Project_Images/Blooms_logo.png'
import mm from '../../../assets/Project_Images/MM_logo.png'
import {
  ApiDeleteBookedTrainings,
  ApiGetAllocationCriteriaDetails,
  ApiGetBookedTrainings,
  appliedAllocations,
  fetchAllocations,
} from "../../../apiService/Core/Apicall.tsx";
import Loading from "../../Loader/Loading.tsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import store, { RootState } from "../../../Redux/Store.tsx";
import { hideLoading, showLoading } from "../../../Redux/loadingSlice.tsx";
import { setSelectedMonth } from "../../../Redux/MonthSlice.tsx";
import { toast } from "react-toastify";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

function TrainingCalendar() {
  // Function name remains 'Calendar'
  const defaultMonth = useSelector((state: RootState) => state.month.selectedMonth)
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs(defaultMonth));
  const [SlotList, setSlotList] = useState<any>();
  const [events, setEvents] = useState<{ title: string; start: string }[]>([]);
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const loading = useSelector((state: RootState) => state.loader.isLoading);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);

  const handlePrevMonth = () => {
    const newMonth = dayjs(defaultMonth).subtract(1, "month").toISOString();
    dispatch(setSelectedMonth(newMonth));
  };

  // Handle Next Month
  const handleNextMonth = () => {
    const newMonth = dayjs(defaultMonth).add(1, "month").toISOString();
    dispatch(setSelectedMonth(newMonth));
  };

  const prevParams = useRef({ month: null, year: null });

  const fetchBookedSlots = async () => {
    setSlotList([])
    try {
      const data = `?month=${selectedDate?.month() + 1}&year=${selectedDate?.year()}`
      const res = await ApiGetBookedTrainings(data)
      if (res.status) {
        setSlotList(res?.data?.shopperSlots)
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      console.log(message)
    }
  }
  useEffect(() => {
    const month: any = selectedDate?.month() + 1;
    const year: any = selectedDate?.year();
    // Prevent duplicate API calls
    if (prevParams.current.month === month && prevParams.current.year === year) {
      return;
    }
    prevParams.current = { month, year };
    selectedDate && fetchBookedSlots();
  }, [selectedDate]);

  useEffect(() => {
    if (SlotList?.length > 0) {
      const formattedEvents = SlotList.map((item: any, index: number) => ({
        title: item?.slotId,
        start: item?.slotStart?.replace(" ", "T") + ".000Z",
        extendedProps: {
          item: item,
        },
      }));

      setEvents(formattedEvents);
    }
  }, [SlotList, selectedDate]);

  const navigate = useNavigate();
  const handleClick = (allocationId: Number, month: number, year: number) => {
    const selectedDateFromMonthYear = `${year}-${String(month).padStart(2, "0")}-01`;
    navigate("/dashboard/MyTasks", {
      state: {
        taskId: allocationId,
        selecteddatefromcalender: selectedDateFromMonthYear,
      },
    });
    localStorage.setItem("ActiveTask", "MyTask");
  };

  const handleDeleteSlot = async () => {
    const isdelete = window.confirm("Are you sure you want to delte this slot ?")
    if (isdelete) {
      try {
        const data = {
          slotId: selectedEvent?.slotId,
          shopperUserId: userData?.userId,
          allocationId: selectedEvent?.allocationId?.allocationId,
          modifiedBy: userData?.userId
        }
        const res = await ApiDeleteBookedTrainings(data)
        if (res.status) {
          setSelectedEvent(null)
          setOpen(false)
          fetchBookedSlots()
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          String(error);
        console.log(message)
      }
    }
    else {
      return
    }
  }

  const renderEventContent = (eventInfo: any) => {
    const event = eventInfo.event.extendedProps;

    // Default colors
    let cardColor = "#ADB792";
    let fontColor = "#ffffff";
    return (
      <Box

        // border="2px solid #FFCB67"
        bgcolor={cardColor}
        color={fontColor}
        className="h-100 mb-2 mx-auto"
        padding="10px"
        // width={'150px'}
        width={'85%'}
        boxSizing='content-box'
        // maxWidth={'170px'}
        borderRadius="10px"
      >
        {/* <Checkbox  /> */}
        <Box onClick={() => {
          setSelectedEvent(event?.item)
          setOpen(true)
          // handleClick(event?.item?.allocationId?.allocationId, event?.item?.allocationId?.jobMonth, event?.item?.allocationId?.jobYear)
        }} sx={{ cursor: 'pointer' }} >
          <Box className='pb-0 align-items-stretch gap-1 d-flex w-100'>
            <Box>
              <Box
                className="p-3 d-flex flex-column"
                borderRadius="50px"
                bgcolor={"#BF613B"}
              >
                <Typography
                  className="text-white text-cen fw-bold text-center"
                  variant="subtitle1"
                >
                  {dayjs.utc(event?.item?.slotStart).local().format("hh:mm")}
                </Typography>

                <Typography
                  className="text-white text-center"
                  variant="caption"
                  lineHeight='normal'
                >
                  {dayjs.utc(event?.item?.slotStart).local().format("A")}
                </Typography>
              </Box>
            </Box>
            <Box className={"d-flex flex-column align-items-start justify-content-start mt-1"}>
              <Typography className="text-dark" style={{ textWrap: 'wrap' }}>{event?.item?.allocationId?.venueId?.venueName}</Typography>
              <Typography variant="body2" className="text-dark" style={{ textWrap: 'wrap' }}><span>T: {event?.item?.availabilityId?.adminUserId?.firstName} {event?.item?.availabilityId?.adminUserId?.lastName}</span></Typography>
            </Box>
            <Box className='d-flex align-items-end'>
              <Box component='img' src={event?.allocationId?.clientgroup === 'ALDI' ? aldi : event?.allocationId?.clientgroup == 'BLOOMS' ? blooms : mm} bgcolor='white' height='24px' width='24px' borderRadius='50px' />
            </Box>
            {/* <Box className='pb-2 mb-2 d-flex w-100' borderBottom='1px solid black'>
              <Typography className="mx-2" sx={{ whiteSpace: 'wrap' }}>{event?.allocationId?.venueName}</Typography> <Typography></Typography>
            </Box> */}
          </Box>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    setSelectedDate(dayjs(defaultMonth))
  }, [defaultMonth])

  return (
    <Box className="p-3" height="calc(100vh - 65px)">
      {SlotList?.data?.length > 0 &&
        SlotList.data.map((item: any, index: number) => (
          <Typography key={index}>{item.appliedAllocationId}</Typography>
        ))}

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          display="flex"
          alignItems="center"
          width="fit-content"
          maxWidth="330px"
          className="d-flex ms-auto mb-2 align-items-center month-calendar justify-content-start"
        >
          {/* Previous Month Button */}
          <IconButton onClick={handlePrevMonth} className="d-none d-md-block">
            <KeyboardArrowLeft />
          </IconButton>

          <DatePicker
            views={["year", "month"]}
            value={selectedDate}
            onChange={(date) => date && dispatch(setSelectedMonth(date.toISOString()))}
            renderInput={(params: any) => (
              <TextField {...params} variant="standard" />
            )}
          />

          <IconButton onClick={handleNextMonth} className="d-none d-md-block">
            <KeyboardArrowRight />
          </IconButton>
        </Box>
      </LocalizationProvider>
      <FullCalendar
        height="calc(100% - 50px)"
        plugins={[dayGridPlugin]}
        // plugins={[dayGridPlugin, timeGridPlugin]}
        key={selectedDate.format("YYYY-MM-DD")}
        initialView="dayGridMonth"
        // initialView="timeGridWeek"
        initialDate={selectedDate.format("YYYY-MM-DD")}
        showNonCurrentDates={false}
        events={events}
        eventContent={renderEventContent}
        eventBackgroundColor="transparent"
        eventBorderColor="transparent"
      />

      {loading && <Loading />}

      <Dialog open={open} onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            maxWidth: "800px !important",
            width: "fit-content !important",
            minWidth: "500px",
            borderRadius: "12px",
            display: 'flex',
            justifyContent: 'start'
          }
        }}
      >
        <Box className='w-100 p-3'>
          <Typography variant="h5" className="text-start mb-3">
            Training Details
          </Typography>
          <Typography gutterBottom>
            Site: {selectedEvent?.allocationId?.venueId?.venueName}
          </Typography>
          <Typography gutterBottom>
            Training Date:{" "}
            {dayjs(
              selectedEvent?.slotStart?.replace(" ", "T") + ".000Z"
            ).format("DD/MM/YYYY")}
          </Typography>
          <Typography gutterBottom>
            Training Time: {`${dayjs(selectedEvent?.slotStart?.replace(" ", "T") + ".000Z").format("hh:mm A")}`}
          </Typography>
          <Typography gutterBottom>
            Trainer Name: {selectedEvent?.availabilityId?.adminUserId?.firstName} {selectedEvent?.availabilityId?.adminUserId?.lastName}
          </Typography>
          <Box className='d-flex mt-3 align-items-center justify-content-center' gap={2}>
            <Button className="bg-third text-white px-3" onClick={() => { handleDeleteSlot() }}>
              Delete Slot
            </Button>
            <Button className="bg-second text-white px-3" onClick={() => { handleClick(selectedEvent?.allocationId?.allocationId, selectedEvent?.allocationId?.jobMonth, selectedEvent?.allocationId?.jobYear) }}>
              View task
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}

export default TrainingCalendar;
